import { JSX, ComponentChild, h } from 'preact'
import Icon from '../assets'
import classNames from 'classnames'

type Props = {
  text?: string | ComponentChild,
  variant?: 'info' | 'success' | 'warning' | 'danger',
  children?: JSX.Element,
  fullWidth?: boolean
}

export const InformationCallout = ({ text, variant = 'info', children, fullWidth } : Props) => {
  const baseClass = 'panel-form-information'
  const className = classNames(
    baseClass,
    variant ? `${baseClass}--${variant}` : `${baseClass}--secondary`,
    fullWidth && `${baseClass}--fullWidth`
  )

  let hasChildren = (Array(children).toString() !== '')
  const iconType: 'info' | 'answer' | 'warning' = variant === 'success' ? 'answer' : variant === 'danger' ? 'warning' : variant

  return <div className={className}>
    <Icon icon={iconType} width={20} height={20} />
    { hasChildren ? children : <div className='panel-form-text'>{text}</div> }
  </div>
}
